import React, { useState, useEffect, useRef } from 'react';

import ModalContext from '../context/ModalContext'; // Provide modal context

// Import all article components

import WebdesignArticle from '../components/WebdesignArticle';
import BlogPostSalonBayern from '../components/blog/BlogPost_SalonBayern';
import BlogPostHandwerkerSEO from '../components/blog/BlogPost_HandwerkerSEO';
import BlogPostOnlineMarketingStrategien from '../components/blog/BlogPostOnlineMarketingStrategien';
import DigitalMarketingArticle from '../components/DigitalMarketingArticle';
import SeoMasterclassArticle from '../components/SeoMasterclassArticle';
import BookingSystemArticle from '../components/BookingSystemArticle';
import ReputationManagementArticle from '../components/ReputationManagementArticle';
import EmailMarketingArticle from '../components/EmailMarketingArticle';
import PerformanceMarketingAgenturArticle from '../components/PerformanceMarketingAgenturArticle';
import WerbeagenturArticle from '../components/WerbeagenturArticle';
import FullServiceAgenturArticle from '../components/FullServiceAgenturArticle';
import OnlineMarketingAgenturArticle from '../components/OnlineMarketingAgenturArticle';
import DigitalagenturArticle from '../components/DigitalagenturArticle';
import SeoAgenturArticle from '../components/SeoAgenturArticle';
import LocalSeoAgenturArticle from '../components/LocalSeoAgenturArticle';
import GoogleAdsAgenturArticle from '../components/GoogleAdsAgenturArticle';
import KiAgenturArticle from '../components/KiAgenturArticle';
import PaidAdvertisingArticle from '../components/PaidAdvertisingArticle';

const articlesToCount = [

  { name: 'Webdesign Checkliste', Component: WebdesignArticle },
  { name: 'Blog: Website für Schönheitssalon Bayern', Component: BlogPostSalonBayern },
  { name: 'Blog: Lokale SEO für Handwerker', Component: BlogPostHandwerkerSEO },
  { name: 'Blog: Online-Marketing-Strategien', Component: BlogPostOnlineMarketingStrategien },
  { name: 'Digitales Marketing für Salons & Handwerker', Component: DigitalMarketingArticle },
  { name: 'SEO Masterclass', Component: SeoMasterclassArticle },
  { name: 'Online Buchungssystem Masterclass', Component: BookingSystemArticle },
  { name: 'Reputationsmanagement Masterclass', Component: ReputationManagementArticle },
  { name: 'E-Mail-Marketing Masterclass', Component: EmailMarketingArticle },
  { name: 'Performance Marketing Agentur', Component: PerformanceMarketingAgenturArticle },
  { name: 'Werbeagentur', Component: WerbeagenturArticle },
  { name: 'Full Service Agentur', Component: FullServiceAgenturArticle },
  { name: 'Online-Marketing Agentur', Component: OnlineMarketingAgenturArticle },
  { name: 'Digitalagentur', Component: DigitalagenturArticle },
  { name: 'SEO Agentur', Component: SeoAgenturArticle },
  { name: 'Local SEO Agentur', Component: LocalSeoAgenturArticle },
  { name: 'Google Ads Agentur', Component: GoogleAdsAgenturArticle },
  { name: 'KI-Agentur', Component: KiAgenturArticle },
  { name: 'Paid Advertising für Salons & Handwerker', Component: PaidAdvertisingArticle },
];

const WordCounter = ({ Component, onCounted }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    if (containerRef.current) {
      const text = containerRef.current.innerText || '';
      const wordCount = text.trim().split(/\s+/).filter(Boolean).length;
      onCounted(wordCount);
    }
  }, [onCounted]);

  return (
    <div style={{ display: 'none' }} ref={containerRef}>
      <ModalContext.Provider value={{ openModal: () => {} }}>
        <Component />
      </ModalContext.Provider>
    </div>
  );
};

const WordCountPage = () => {
  const [counts, setCounts] = useState({});

  const handleCounted = (name, count) => {
    setCounts(prevCounts => ({ ...prevCounts, [name]: count }));
  };

  return (
    <div style={{ fontFamily: 'Arial, sans-serif', maxWidth: '800px', margin: '2rem auto', padding: '2rem', borderRadius: '8px', boxShadow: '0 4px 8px rgba(0,0,0,0.1)' }}>
      <h1 style={{ textAlign: 'center', borderBottom: '2px solid #eee', paddingBottom: '1rem', marginBottom: '2rem' }}>Artikel Wortanzahl</h1>
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr>
            <th style={{ borderBottom: '1px solid #ddd', padding: '12px', textAlign: 'left', backgroundColor: '#f2f2f2' }}>Artikel</th>
            <th style={{ borderBottom: '1px solid #ddd', padding: '12px', textAlign: 'right', backgroundColor: '#f2f2f2' }}>Wortanzahl</th>
          </tr>
        </thead>
        <tbody>
          {articlesToCount.map(({ name, Component }) => (
            <tr key={name}>
              <td style={{ borderBottom: '1px solid #eee', padding: '12px' }}>{name}</td>
              <td style={{ borderBottom: '1px solid #eee', padding: '12px', textAlign: 'right', fontWeight: 'bold' }}>
                {counts[name] !== undefined ? counts[name] : 'Zählen...'}
              </td>
              {counts[name] === undefined && (
                <WordCounter Component={Component} onCounted={(count) => handleCounted(name, count)} />
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default WordCountPage;
